module.exports = __webpack_public_path__ + "static/media/Johan&Carma(3).9c94f652.jpg";